import React from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import LozengeIcon from '@atlaskit/icon-lab/core/lozenge';
import Lozenge from '@atlaskit/lozenge';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, Inline, Stack } from '@atlaskit/primitives/compiled';
import {
	type AddStatusRovoPayload,
	type DeleteStatusRovoPayload,
} from '@atlaskit/rovo-triggers/types';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const statusCategoryToAppearenceMap = {
	UNDEFINED: 'neutral',
	TODO: 'neutral',
	DONE: 'success',
	IN_PROGRESS: 'information',
} as const;

const styles = cssMap({
	statusIcon: {
		width: '24px',
		height: '24px',
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderRadius: token('radius.small'),
		color: token('color.text.accent.gray'),
	},
	card: {
		width: '100%',
		paddingTop: token('space.150'),
		paddingRight: token('space.150'),
		paddingBottom: token('space.150'),
		paddingLeft: token('space.150'),
		borderStyle: 'solid',
		borderRadius: token('radius.small'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		backgroundColor: token('elevation.surface.raised'),
	},
});

export const StatusAction = (
	payload: AddStatusRovoPayload | DeleteStatusRovoPayload,
): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack space="space.100">
			<Heading size="xsmall">{formatMessage(messages.statusHeading)}</Heading>
			<Inline xcss={styles.card} alignBlock="center" space="space.150">
				<Flex xcss={styles.statusIcon} justifyContent="center" alignItems="center">
					<LozengeIcon label="" />
				</Flex>
				<Lozenge appearance={statusCategoryToAppearenceMap[payload.statusCategory]}>
					{payload.statusName}
				</Lozenge>
			</Inline>
		</Stack>
	);
};
